<app-apps-banner></app-apps-banner>
<app-home-apps></app-home-apps>
<app-sat></app-sat>
<router-outlet></router-outlet>
